import { createFileRoute } from "@tanstack/react-router";

import PrivacyRoute from "@/components/Legals/PrivacyRoute";

export const Route = createFileRoute("/privacy")({
  component: PrivacyRoute,
});
